export default __webpack_public_path__ + "static/media/163a066c2b2fcd.14ba2699.jpg";